import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { CartProvider } from './context/CartContext';
import { clearBrowserCachesAfterInactivity } from './utils/browserCache';

const renderApp = async () => {
  try {
    await clearBrowserCachesAfterInactivity();
  } catch (error) {
    console.warn('No se pudo actualizar el cache antes de iniciar.', error);
  }

  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );
  root.render(
    <CartProvider>
      <App />
    </CartProvider>
  );
};

void renderApp();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
